<template>
    <div class="access-password-overlay" v-if="!isVerified">
        <div class="access-password-box">
            <div class="logo">
                <img src="@/assets/images/logo.png" alt="弗顿" />
            </div>
            <h2>网站访问验证</h2>
            <p>请输入访问密码继续浏览</p>
            <div class="input-wrapper">
                <input
                    type="password"
                    v-model="password"
                    placeholder="请输入密码"
                    @keyup.enter="verifyPassword"
                    ref="passwordInput"
                />
            </div>
            <div class="error-msg" v-if="errorMsg">{{ errorMsg }}</div>
            <button class="verify-btn" @click="verifyPassword">进入网站</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AccessPassword',
    data() {
        return {
            password: '',
            errorMsg: '',
            isVerified: false,
            correctPassword: '123456'
        }
    },
    created() {
        // 检查是否已经验证过
        const verified = sessionStorage.getItem('access_verified')
        if (verified === 'true') {
            this.isVerified = true
        }
    },
    mounted() {
        if (!this.isVerified) {
            this.$nextTick(() => {
                this.$refs.passwordInput && this.$refs.passwordInput.focus()
            })
        }
    },
    methods: {
        verifyPassword() {
            if (!this.password) {
                this.errorMsg = '请输入密码'
                return
            }
            if (this.password === this.correctPassword) {
                this.isVerified = true
                sessionStorage.setItem('access_verified', 'true')
                this.errorMsg = ''
            } else {
                this.errorMsg = '密码错误，请重新输入'
                this.password = ''
            }
        }
    }
}
</script>

<style lang="less" scoped>
.access-password-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999999;
}

.access-password-box {
    background: #fff;
    padding: 40px 50px;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    text-align: center;
    min-width: 320px;
    max-width: 400px;
    width: 90%;

    .logo {
        margin-bottom: 20px;

        img {
            width: 120px;
            height: auto;
        }
    }

    h2 {
        font-size: 24px;
        color: #333;
        margin-bottom: 10px;
        font-weight: 600;
    }

    p {
        font-size: 14px;
        color: #666;
        margin-bottom: 25px;
    }

    .input-wrapper {
        margin-bottom: 15px;

        input {
            width: 100%;
            padding: 12px 15px;
            border: 2px solid #e0e0e0;
            border-radius: 8px;
            font-size: 16px;
            transition: border-color 0.3s;
            box-sizing: border-box;

            &:focus {
                outline: none;
                border-color: #d61818;
            }

            &::placeholder {
                color: #aaa;
            }
        }
    }

    .error-msg {
        color: #d61818;
        font-size: 14px;
        margin-bottom: 15px;
    }

    .verify-btn {
        width: 100%;
        padding: 12px 20px;
        background: #d61818;
        color: #fff;
        border: none;
        border-radius: 8px;
        font-size: 16px;
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
            background: #b51414;
        }

        &:active {
            background: #9a1111;
        }
    }
}

@media (max-width: 768px) {
    .access-password-box {
        padding: 30px 25px;

        .logo img {
            width: 100px;
        }

        h2 {
            font-size: 20px;
        }

        p {
            font-size: 13px;
        }
    }
}
</style>
